import React, { useState } from 'react';
import { Sheet, ArrowRight, ShieldCheck } from 'lucide-react';
interface SetupScreenProps {
  onConnect: (url: string) => void;
}
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/2u6MreNFCJLYjGpiWQ46Uw/ELITE_UTILS_(14).png';
export function SetupScreen({
  onConnect
}: SetupScreenProps) {
  const [url, setUrl] = useState('');
  const handleConnect = () => {
    const v = url.trim();
    if (!v.includes('/exec')) {
      alert('La URL debe terminar en /exec');
      return;
    }
    onConnect(v);
  };
  return <div className="max-w-[520px] mx-auto mt-10 md:mt-16" data-id="element-177">
      <div className="flex justify-center mb-8" data-id="element-178">
        <img src={LOGO_URL} alt="parquet72h" className="h-14 md:h-16 w-auto object-contain" data-id="element-179" />
      </div>

      <div className="bg-white border border-line rounded-3xl p-7 md:p-8 shadow-card relative overflow-hidden" data-id="element-180">
        <div className="absolute -top-12 -right-12 w-40 h-40 bg-wood/5 rounded-full blur-2xl pointer-events-none" data-id="element-181" />

        <div className="relative" data-id="element-182">
          <div className="inline-flex items-center gap-2 bg-cream-2 text-charcoal-soft text-[11px] font-extrabold uppercase tracking-wider px-3 py-1.5 rounded-full mb-4" data-id="element-183">
            <Sheet className="w-3.5 h-3.5 text-wood" data-id="element-184" />
            Conexión
          </div>

          <h3 className="text-[22px] font-poppins font-extrabold mb-2 leading-tight" data-id="element-185">
            Conecta tu Google Sheet
          </h3>
          <p className="text-[13.5px] text-charcoal-soft mb-6 leading-relaxed" data-id="element-186">
            Pega la URL del Apps Script que publicaste (acaba en{' '}
            <code className="bg-cream-2 px-1.5 py-0.5 rounded text-[12px] font-mono" data-id="element-187">
              /exec
            </code>
            ). Solo se configura una vez por dispositivo.
          </p>

          <label className="block text-[11.5px] font-extrabold uppercase tracking-wider text-charcoal-soft mb-2" data-id="element-188">
            URL de la API
          </label>
          <input value={url} onChange={e => setUrl(e.target.value)} placeholder="https://script.google.com/macros/s/.../exec" className="w-full border border-line rounded-xl px-4 py-3 font-manrope text-[14px] mb-5 focus:outline-none focus:border-wood focus:ring-2 focus:ring-wood/20 transition-all" data-id="element-189" />

          <button onClick={handleConnect} className="w-full bg-charcoal text-white font-manrope font-extrabold rounded-xl px-4 py-3.5 text-[14.5px] hover:bg-charcoal-soft active:scale-[0.98] transition-all flex items-center justify-center gap-2 group" data-id="element-190">
            Conectar y empezar
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" strokeWidth={3} data-id="element-191" />
          </button>

          <div className="mt-5 flex items-center gap-2 text-[11.5px] text-charcoal-soft/70" data-id="element-192">
            <ShieldCheck className="w-3.5 h-3.5" data-id="element-193" />
            La URL se guarda solo en tu navegador.
          </div>
        </div>
      </div>
    </div>;
}